<template>
  <div class="collapsibleFormInputContainer">
    <h3 class="form-map-title">
      <span>FILTRAR POR PATENTE</span>
    </h3>
    <BaseSearchVehicle @sendPatent="setPatent"
                       @submit.native="searchByVehicle"/>
    <div class="form-map-footer">
      <BaseButton :text="'Buscar'"
                  :on="form.patent.vehicles_patent !== ''"
                  :event="searchByVehicle"/>
    </div>
  </div>
</template>

<script>
import BaseButton from './BaseButton.vue';
import BaseSearchVehicle from './BaseSearchVehicle.vue';
import { apiRequest } from '../../backend/vue-axios/axios';
import { AxiosCaller } from '../../mixins/taskQueue';

export default {
  props: ['tracing_code'],
  name: 'RoutesForm',
  components: {
    BaseButton,
    BaseSearchVehicle,
  },
  data() {
    return {
      caller: new AxiosCaller(),
      form: {
        patent: {
          vehicles_patent: '',
        },
        region: {
          regions_id: -1,
        },
        commune: {
          communes_id: -1,
        },
        distributionCenter: {
          distribution_centers_id: -1,
        },
        enterprise: {
          enterprises_id: '',
        },
        tracing: {
          tracing_code: '',
        },
      },
      tabPosition: 'up',
      routes: [],
    };
  },
  methods: {
    setPatent(patent) {
      this.form.patent.vehicles_patent = patent.toUpperCase();
    },
    setRegion(regionId) {
      this.form.region.regions_id = regionId;
    },
    setCommune(communeId) {
      this.form.commune.communes_id = communeId;
    },
    setDistCenter(distCenterId) {
      this.form.distributionCenter.distribution_centers_id = distCenterId;
    },
    setEnterprise(enterpriseId) {
      this.form.enterprise.enterprises_id = enterpriseId;
    },
    setTracing(tracingCode) {
      this.form.tracing.tracing_code = tracingCode;
    },
    searchByVehicle(event) {
      this.$emit('sendLocations', []);
      this.$emit('loading', true);
      event.preventDefault();
      this.caller.Call('rutas', apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: this.form.patent,
      })).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.routes = response.data;
        }
        this.$emit('loading', false);
      }).catch(() => {
        this.$message.error('Hubo un error al obtener las rutas');
        this.$emit('loading', false);
      });
    },
    searchByDistCenter() {
      this.$emit('sendLocations', []);
      this.$emit('loading', true);
      this.caller.Call('rutas', apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: this.form.distributionCenter,
      })).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.routes = response.data;
        }
        this.$emit('loading', false);
      }).catch(() => {
        this.$message.error('Hubo un error al obtener las rutas');
        this.$emit('loading', false);
      });
    },
    searchByEnterprise() {
      this.$emit('sendLocations', []);
      this.$emit('loading', true);
      this.caller.Call('rutas', apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: this.form.enterprise,
      })).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.routes = response.data;
        }
        this.$emit('loading', false);
      }).catch(() => {
        this.$message.error('Hubo un error al obtener las rutas');
        this.$emit('loading', false);
      });
    },
    searchByRegion() {
      this.$emit('sendLocations', []);
      this.$emit('loading', true);
      this.caller.Call('rutas', apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: {
          regions_id: this.form.region.regions_id,
          communes_id: this.form.commune.communes_id,
        },
      })).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.routes = response.data;
        }
        this.$emit('loading', false);
      }).catch(() => {
        this.$message.error('Hubo un error al obtener las rutas');
        this.$emit('loading', false);
      });
    },
    searchByTracing(event) {
      event.preventDefault();
      this.searchTracing();
    },
    searchTracing() {
      this.$emit('sendLocations', []);
      this.$emit('loading', true);
      this.caller.Call('rutas', apiRequest({
        module: 'tracing',
        service: 'get_routes_tracing',
        params: { routes_planning_statuses_id: this.form.tracing.tracing_code },
      })).then((response) => {
        if (response.data.length === 0) {
          this.$message.warning('No se encontró ninguna ruta');
        } else {
          this.routes = response.data;
        }
        this.$emit('loading', false);
      }).catch(() => {
        this.$message.error('Hubo un error al obtener las rutas');
        this.$emit('loading', false);
      });
    },
  },
  mounted() {
    if (this.$route.query.tracing_code) {
      this.form.tracing.tracing_code = this.$route.query.tracing_code;
      this.searchTracing(this.form.tracing);
    }
  },
  watch: {
    routes: function sendRoutes() {
      this.$emit('sendLocations', this.routes);
    },
  },
};
</script>

<style lang="scss" scoped>
  .close {
    cursor: pointer;
  }
  .form-map-title {
    margin-left: 0;
    margin-bottom: 1em;
    margin-top: 0.5em;
  }
  .plainSwitchStyle {
    display: flex;
    justify-content: space-between;
  }
</style>
